export default {
  ANIMATION: {
    scaleUpVerCenter: {
      className: 'scaleUpVerCenter',
      name: 'scaleUpVerCenter',
    },
    scaleUpVerBottom: {
      className: 'scaleUpVerBottom',
      name: 'scaleUpVerBottom',
    },
    scaleDownVerTop: { className: 'scaleDownVerTop', name: 'scaleDownVerTop' },
    swingBottomBck: { className: 'swingBottomBck', name: 'swingBottomBck' },
  },
};
